import { UAParser } from "ua-parser-js";

export interface ClientInfo {
    browser:string;
    browserVersion:string;
    os:string;
    osVersion:string;
    deviceType:string;
    engine:string;
    engineVersion:string;
    userAgent:string;
    language:string;
    screen:string;
    url:string;
    online:boolean;
}

export function getClientInfo():ClientInfo {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    browser: result.browser.name || "Desconocido",
    browserVersion: result.browser.version || "N/A",
    os: result.os.name || "Desconocido",
    osVersion: result.os.version || "N/A",
    deviceType:
      result.device.type || (window.innerWidth < 768 ? "Mobile" : "Desktop"),
    engine: result.engine.name || "Unknown",
    engineVersion: result.engine.version || "",
    userAgent: result.ua,
    language: navigator.language,
    screen: `${window.screen.width}x${window.screen.height}`,
    url: window.location.href,
    online: navigator.onLine,
  };
}
